(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-experience')) {
    class AboutExperience extends HTMLElement {
      #sceneObserver = null;
      #kilnObserver = null;
      #hintObserver = null;
      #raf = 0;
      #holdRaf = 0;
      #holdStart = 0;
      #holdActive = false;
      #kilnFired = false;
      #revealTimer = 0;
      #flameTimer = 0;
      #hintTimer = 0;
      #stepCount = 0;
      #kilnStory = null;
      #kilnSurface = null;
      #temperatureOutput = null;
      #holdButton = null;
      #holdLabel = null;
      #kilnLive = null;
      #mobileKiln = window.matchMedia('(max-width: 989px)');
      #reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      connectedCallback() {
        this.classList.add('is-enhanced');
        this.#setupKilnInteraction();

        if (this.#reducedMotion.matches) {
          for (const scene of this.querySelectorAll('[data-story-scene]')) scene.classList.add('is-active');
          this.#setInitialStage();
          this.#completeKiln(false);
          return;
        }

        this.#observeScenes();
        this.#observeKilnSteps();
        this.#observeKilnHint();
        window.addEventListener('scroll', this.#onScroll, { passive: true });
        window.addEventListener('resize', this.#onScroll, { passive: true });
        this.#mobileKiln.addEventListener('change', this.#onKilnModeChange);
        this.#onScroll();
      }

      disconnectedCallback() {
        this.#sceneObserver?.disconnect();
        this.#kilnObserver?.disconnect();
        this.#hintObserver?.disconnect();
        window.removeEventListener('scroll', this.#onScroll);
        window.removeEventListener('resize', this.#onScroll);
        this.#mobileKiln.removeEventListener('change', this.#onKilnModeChange);
        this.#removeKilnInteraction();
        if (this.#raf) cancelAnimationFrame(this.#raf);
        if (this.#holdRaf) cancelAnimationFrame(this.#holdRaf);
        if (this.#revealTimer) window.clearTimeout(this.#revealTimer);
        if (this.#flameTimer) window.clearTimeout(this.#flameTimer);
        if (this.#hintTimer) window.clearTimeout(this.#hintTimer);
      }

      #observeScenes() {
        this.#sceneObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-active');
            this.#sceneObserver.unobserve(entry.target);
          }
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

        for (const scene of this.querySelectorAll('[data-story-scene]')) this.#sceneObserver.observe(scene);
      }

      #observeKilnSteps() {
        const story = this.querySelector('.about-experience__kiln-story');
        const label = this.querySelector('[data-stage-current]');
        if (!story) return;

        this.#kilnObserver = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!visible) return;
          story.dataset.kilnStage = visible.target.dataset.kilnStep;
          if (label) label.textContent = visible.target.dataset.stageLabel || '';
        }, { rootMargin: '-34% 0px -46% 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });

        for (const step of this.querySelectorAll('[data-kiln-step]')) this.#kilnObserver.observe(step);
        this.#setInitialStage();
      }

      #setInitialStage() {
        const first = this.querySelector('[data-kiln-step]');
        const label = this.querySelector('[data-stage-current]');
        if (first && label) label.textContent = first.dataset.stageLabel || '';
      }

      #setupKilnInteraction() {
        this.#kilnStory = this.querySelector('.about-experience__kiln-story');
        this.#kilnSurface = this.querySelector('.about-experience__kiln');
        this.#temperatureOutput = this.querySelector('[data-kiln-temperature]');
        this.#holdButton = this.querySelector('[data-kiln-hold]');
        this.#holdLabel = this.querySelector('[data-kiln-hold-label]');
        this.#kilnLive = this.querySelector('[data-kiln-live]');
        if (!this.#kilnStory || !this.#holdButton) return;

        this.#holdButton.addEventListener('pointerdown', this.#onHoldPointerDown);
        this.#holdButton.addEventListener('pointerup', this.#onHoldPointerEnd);
        this.#holdButton.addEventListener('pointercancel', this.#onHoldPointerEnd);
        this.#holdButton.addEventListener('keydown', this.#onHoldKeyDown);
        this.#holdButton.addEventListener('keyup', this.#onHoldKeyUp);
        this.#holdButton.addEventListener('blur', this.#onHoldBlur);
        this.#holdButton.addEventListener('click', this.#preventHoldClick);
        // On mobile the photo itself doubles as the hold surface (the handlers
        // no-op on desktop, where scrolling drives the firing instead).
        this.#kilnSurface?.addEventListener('pointerdown', this.#onSurfacePointerDown);
        this.#kilnSurface?.addEventListener('pointerup', this.#onHoldPointerEnd);
        this.#kilnSurface?.addEventListener('pointercancel', this.#onHoldPointerEnd);
        this.#kilnSurface?.addEventListener('contextmenu', this.#onSurfaceContextMenu);
        this.#renderKilnProgress(0);
      }

      #removeKilnInteraction() {
        if (!this.#holdButton) return;
        this.#holdButton.removeEventListener('pointerdown', this.#onHoldPointerDown);
        this.#holdButton.removeEventListener('pointerup', this.#onHoldPointerEnd);
        this.#holdButton.removeEventListener('pointercancel', this.#onHoldPointerEnd);
        this.#holdButton.removeEventListener('keydown', this.#onHoldKeyDown);
        this.#holdButton.removeEventListener('keyup', this.#onHoldKeyUp);
        this.#holdButton.removeEventListener('blur', this.#onHoldBlur);
        this.#holdButton.removeEventListener('click', this.#preventHoldClick);
        this.#kilnSurface?.removeEventListener('pointerdown', this.#onSurfacePointerDown);
        this.#kilnSurface?.removeEventListener('pointerup', this.#onHoldPointerEnd);
        this.#kilnSurface?.removeEventListener('pointercancel', this.#onHoldPointerEnd);
        this.#kilnSurface?.removeEventListener('contextmenu', this.#onSurfaceContextMenu);
      }

      #onHoldPointerDown = (event) => {
        if (event.button !== 0 || this.#kilnFired) return;
        event.preventDefault();
        try {
          event.currentTarget.setPointerCapture?.(event.pointerId);
        } catch (error) {
          // A pointer that vanished before capture shouldn't kill the hold.
        }
        this.#beginHold();
      };

      #onSurfacePointerDown = (event) => {
        if (!this.#mobileKiln.matches) return;
        this.#onHoldPointerDown(event);
      };

      #onSurfaceContextMenu = (event) => {
        // Android raises a long-press context menu on the image mid-hold.
        if (this.#mobileKiln.matches && this.#holdActive) event.preventDefault();
      };

      #onHoldPointerEnd = (event) => {
        if (event.currentTarget.hasPointerCapture?.(event.pointerId)) {
          event.currentTarget.releasePointerCapture(event.pointerId);
        }
        this.#cancelHold();
      };

      #onHoldKeyDown = (event) => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        if (!event.repeat) this.#beginHold();
      };

      #onHoldKeyUp = (event) => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        this.#cancelHold();
      };

      #onHoldBlur = () => {
        this.#cancelHold();
      };

      #preventHoldClick = (event) => {
        event.preventDefault();
      };

      #beginHold() {
        if (this.#holdActive || this.#kilnFired) return;
        this.#holdActive = true;
        this.#holdStart = performance.now();
        this.#hideTouchHint();
        this.#kilnStory?.classList.add('is-holding');
        this.#renderKilnProgress(0);
        this.#holdRaf = requestAnimationFrame(this.#tickHold);
      }

      #tickHold = (time) => {
        if (!this.#holdActive) return;
        const progress = Math.min((time - this.#holdStart) / 3000, 1);
        this.#renderKilnProgress(progress);

        if (progress >= 1) {
          this.#holdActive = false;
          this.#holdRaf = 0;
          this.#kilnStory?.classList.remove('is-holding');
          this.#completeKiln(true);
          return;
        }

        this.#holdRaf = requestAnimationFrame(this.#tickHold);
      };

      #cancelHold() {
        if (!this.#holdActive) return;
        this.#holdActive = false;
        this.#kilnStory?.classList.remove('is-holding');
        if (this.#holdRaf) cancelAnimationFrame(this.#holdRaf);
        this.#holdRaf = 0;
        if (!this.#kilnFired) {
          this.#renderKilnProgress(0);
          // A released-too-soon hold gets a gentle nudge back to the hint.
          this.#showTouchHint(2800);
        }
      }

      #renderKilnProgress(progress) {
        if (!this.#kilnStory) return;
        const safeProgress = Math.min(Math.max(progress, 0), 1);
        const temperature = Math.round((20 + safeProgress * 1180) / 5) * 5;
        this.#kilnStory.style.setProperty('--kiln-progress', safeProgress.toFixed(4));
        if (this.#temperatureOutput) this.#temperatureOutput.textContent = String(temperature);
      }

      #completeKiln(animate) {
        if (this.#kilnFired || !this.#kilnStory) return;
        this.#kilnFired = true;
        this.#hideTouchHint();
        this.#renderKilnProgress(1);
        this.#holdButton?.setAttribute('disabled', '');

        const reveal = () => {
          this.#kilnStory?.classList.add('is-fired');
          if (this.#holdLabel && this.#holdButton?.dataset.kilnCompleteLabel) {
            this.#holdLabel.textContent = this.#holdButton.dataset.kilnCompleteLabel;
          }
          if (this.#kilnLive && this.#holdButton?.dataset.kilnCompleteMessage) {
            this.#kilnLive.textContent = '';
            requestAnimationFrame(() => {
              this.#kilnLive.textContent = this.#holdButton.dataset.kilnCompleteMessage;
            });
          }
        };

        if (!animate) {
          reveal();
          return;
        }

        this.#kilnStory.classList.add('is-igniting');
        this.#revealTimer = window.setTimeout(reveal, 620);
        this.#flameTimer = window.setTimeout(() => {
          this.#kilnStory?.classList.remove('is-igniting');
        }, 1650);
      }

      /* Mobile only: surface the touch hint briefly the first time the kiln
         scrolls into view, so the press-and-hold affordance lives on the
         photo itself rather than only in the line of text below it. */
      #observeKilnHint() {
        const kiln = this.#kilnSurface;
        if (!kiln || !this.querySelector('[data-kiln-touch]')) return;
        this.#hintObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.#showTouchHint(5200);
            this.#hintObserver?.disconnect();
            this.#hintObserver = null;
          }
        }, { threshold: 0.55 });
        this.#hintObserver.observe(kiln);
      }

      #showTouchHint(duration) {
        if (this.#kilnFired || this.#holdActive || !this.#kilnStory || !this.#mobileKiln.matches) return;
        this.#kilnStory.classList.add('is-touch-hint');
        window.clearTimeout(this.#hintTimer);
        this.#hintTimer = window.setTimeout(() => {
          this.#kilnStory?.classList.remove('is-touch-hint');
        }, duration);
      }

      #hideTouchHint() {
        window.clearTimeout(this.#hintTimer);
        this.#hintTimer = 0;
        this.#kilnStory?.classList.remove('is-touch-hint');
      }

      #updateKilnFromScroll(viewport) {
        if (!this.#kilnStory || this.#mobileKiln.matches || this.#kilnFired) return;
        const rect = this.#kilnStory.getBoundingClientRect();
        const startLine = viewport * 0.72;
        const endLine = viewport * 0.28;
        const travel = Math.max(rect.height - (startLine - endLine), 1);
        // The raw 0..1 progress spans the entire steps column, which made the
        // firing land only at the very last step. Scaling it so the kiln
        // reaches 1200° by the end of step 4 keeps the payoff from dragging
        // (with fewer than 4 steps it simply completes at the last one).
        if (!this.#stepCount) this.#stepCount = this.querySelectorAll('[data-kiln-step]').length || 1;
        const fireFraction = Math.min(4, this.#stepCount) / this.#stepCount;
        const raw = Math.min(Math.max((startLine - rect.top) / travel, 0), 1);
        const progress = Math.min(raw / fireFraction, 1);
        if (progress >= 0.995) {
          this.#completeKiln(true);
          return;
        }
        this.#renderKilnProgress(progress);
      }

      #onKilnModeChange = () => {
        if (!this.#kilnFired) this.#renderKilnProgress(0);
        this.#onScroll();
      };

      #onScroll = () => {
        if (this.#raf) return;
        this.#raf = requestAnimationFrame(() => {
          this.#raf = 0;
          const viewport = window.innerHeight;
          this.#updateKilnFromScroll(viewport);
          for (const item of this.querySelectorAll('[data-about-parallax]')) {
            const rect = item.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > viewport) continue;
            const speed = Number(item.dataset.aboutParallax || 0);
            const progress = (rect.top + rect.height / 2 - viewport / 2) / viewport;
            item.style.setProperty('--about-shift', `${progress * speed}px`);
          }
        });
      };
    }

    customElements.define('about-experience', AboutExperience);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["all-reviews"] && !Shopify.designMode) return;
  try {
    
  // Judge.me renders its all-reviews widget asynchronously and always starts
  // on the "Product Reviews" sub-tab. This activates whichever tab the
  // merchant picked in the section settings (default: shop reviews) as soon
  // as the widget's sub-tabs appear in the DOM, then stops observing.
  const initAllReviewsDefaultTab = (root) => {
    const page = root.querySelector('.all-reviews-page');
    const body = page && page.querySelector('[data-all-reviews]');
    if (!page || !body || body.dataset.defaultTabInit) return;

    const wanted = page.dataset.defaultTab === 'product' ? 'product-reviews' : 'shop-reviews';

    const activate = () => {
      const tab = body.querySelector(`.jdgm-subtab__name[data-tabname="${wanted}"]`);
      if (!tab) return false;
      body.dataset.defaultTabInit = 'true';
      if (!tab.classList.contains('jdgm--active')) tab.click();
      return true;
    };

    if (activate()) return;

    const observer = new MutationObserver(() => {
      if (activate()) observer.disconnect();
    });
    observer.observe(body, { childList: true, subtree: true });
    // Give up quietly if the widget never renders (e.g. Judge.me not loaded).
    setTimeout(() => observer.disconnect(), 15000);
  };

  initAllReviewsDefaultTab(document);
  document.addEventListener('shopify:section:load', (event) => initAllReviewsDefaultTab(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // Mobile announcement slider: auto-advance through the messages one at a
  // time. A clone of the first message is appended so the loop can slide
  // forward past the last message and then jump back to the start without a
  // visible reverse sweep. On >= 990px the CSS shows all messages inline and
  // this leaves the transform cleared, so the slider is mobile-only.
  const initAnnouncementSlider = (root) => {
    const bar = root.querySelector('.announcement-bar');
    if (!bar || bar.dataset.sliderInit) return;
    const track = bar.querySelector('.announcement-bar__list');
    if (!track) return;
    const realCount = track.children.length;
    if (realCount < 2) return; // nothing to rotate
    bar.dataset.sliderInit = 'true';

    const clone = track.firstElementChild.cloneNode(true);
    clone.classList.add('announcement-bar__item--clone');
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);

    const mq = window.matchMedia('(max-width: 989px)');
    let index = 0;
    let timer = null;

    const goTo = (i) => {
      index = i;
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    track.addEventListener('transitionend', (event) => {
      if (event.propertyName !== 'transform') return;
      if (index === realCount) {
        // Landed on the clone of the first slide — snap back without motion.
        track.style.transition = 'none';
        goTo(0);
        void track.offsetWidth; // force reflow so the next move animates again
        track.style.transition = '';
      }
    });

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      timer = setInterval(() => goTo(index + 1), 4500);
    };

    const apply = () => {
      if (mq.matches) {
        goTo(index > realCount ? 0 : index);
        start();
      } else {
        stop();
        track.style.transform = '';
      }
    };

    mq.addEventListener('change', apply);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else if (mq.matches) start();
    });

    apply();
  };

  initAnnouncementSlider(document);
  document.addEventListener('shopify:section:load', (event) => initAnnouncementSlider(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  // Accessible tabs: click or arrow keys switch panels; no page reload.
  const initCollectionTabs = (root) => {
    for (const section of root.querySelectorAll('.collection-tabs')) {
      if (section.dataset.tabsInit) continue;
      section.dataset.tabsInit = 'true';

      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = [...section.querySelectorAll('[role="tabpanel"]')];

      // Refill a panel from a stock-filtered version of its own collection.
      // Liquid can only see a collection's first 50 products from here, and
      // in a mostly sold-out catalogue those rarely include enough pieces
      // worth showing — Shopify does the narrowing far better than we can.
      const fill = async (panel) => {
        const grid = panel?.querySelector('[data-tab-source]');
        if (!grid || grid.dataset.tabFilled) return;
        grid.dataset.tabFilled = 'true';
        try {
          const response = await fetch(grid.dataset.tabSource);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const markup = await response.text();
          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const cards = [...parsed.querySelectorAll('.collection-tabs__item')];
          if (cards.length === 0) return;
          const limit = Number(grid.dataset.tabLimit || 12);
          grid.replaceChildren(...cards.slice(0, limit));
        } catch (error) {
          // Keep whatever the server rendered rather than emptying the tab.
        }
      };

      const activate = (index) => {
        tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          if (panels[i]) panels[i].hidden = !selected;
        });
        fill(panels[index]);
        tabs[index].focus({ preventScroll: true });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          activate((index + step + tabs.length) % tabs.length);
        });
      });

      // The selected tab is server-rendered, then refreshed immediately
      // from Shopify's filtered collection endpoint.
      fill(panels[0]);
    }
  };

  initCollectionTabs(document);
  document.addEventListener('shopify:section:load', (event) => initCollectionTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Auto-submit filters and sorting, while keeping only one compact filter
  // disclosure open at a time.
  const form = document.getElementById('CollectionFilters');
  if (form) {
    form.addEventListener('change', (event) => {
      // The type filter lives inside this form for layout, but it's handled
      // in the browser — submitting would reload and drop the selection.
      if (event.target.closest('[data-type-filter]')) return;
      form.submit();
    });

    const filters = form.querySelectorAll('.collection__filter');
    for (const filter of filters) {
      filter.addEventListener('toggle', () => {
        if (!filter.open) return;
        for (const otherFilter of filters) {
          if (otherFilter !== filter) otherFilter.open = false;
        }
      });
    }

    document.addEventListener('click', (event) => {
      if (form.contains(event.target)) return;
      for (const filter of filters) filter.open = false;
    });
  }

  // ----- Long-form collection copy: trim + expand -----
  // Applied after render so the full text is always in the HTML. The trim is
  // skipped entirely when the copy is short enough to read as-is, so a two-
  // line description never gets a pointless "Read more".
  const collectionCopy = document.querySelector('[data-collection-copy]');
  if (collectionCopy) {
    const CLAMP_HEIGHT = 200; // matches the CSS max-height
    if (collectionCopy.scrollHeight > CLAMP_HEIGHT + 80) {
      collectionCopy.classList.add('is-clamped');

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'collection-copy__toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', collectionCopy.id || 'CollectionCopyBody');
      if (!collectionCopy.id) collectionCopy.id = 'CollectionCopyBody';
      toggle.textContent = collectionCopy.dataset.moreLabel || 'Read more';
      collectionCopy.after(toggle);

      toggle.addEventListener('click', () => {
        const open = collectionCopy.classList.toggle('is-clamped') === false;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open
          ? (collectionCopy.dataset.lessLabel || 'Read less')
          : (collectionCopy.dataset.moreLabel || 'Read more');
        if (!open) toggle.scrollIntoView({ block: 'nearest' });
      });
    }
  }

  // ----- Product type filter -----
  // Hides non-matching cards in the browser. Because the grid streams in
  // page by page, picking a type first pulls the remaining pages so the
  // choice reflects the whole collection, not just what's been scrolled to.
  const typeFilter = document.querySelector('[data-type-filter]');
  const typeGrid = document.querySelector('[data-infinite-grid]');
  if (typeFilter && typeGrid) {
    const infinite = document.querySelector('infinite-collection');
    const options = [...typeFilter.querySelectorAll('[data-type-option]')];
    const badge = typeFilter.querySelector('[data-type-count]');
    const emptyNote = document.querySelector('[data-type-empty]');
    const countEl = document.querySelector('[data-collection-count]');
    const countOne = countEl ? countEl.dataset.countOne || '' : '';
    const countOther = countEl ? countEl.dataset.countOther || '' : '';
    if (countEl) countEl.dataset.countOriginal = countEl.textContent.trim();

    const chosen = () => options.filter((option) => option.checked);

    const paint = () => {
      const active = chosen().map((option) => option.value.toLowerCase());
      let visible = 0;
      for (const item of typeGrid.children) {
        const type = (item.dataset.productType || '').toLowerCase();
        const hide = active.length > 0 && !active.includes(type);
        item.classList.toggle('is-filtered-out', hide);
        if (!hide) visible += 1;
      }
      if (badge) {
        badge.hidden = active.length === 0;
        badge.textContent = String(active.length);
      }
      if (emptyNote) emptyNote.hidden = !(active.length > 0 && visible === 0);
      if (countEl) {
        if (active.length === 0) {
          countEl.textContent = countEl.dataset.countOriginal;
        } else if (visible === 1 && countOne) {
          countEl.textContent = countOne;
        } else {
          countEl.textContent = countOther.replace('[[count]]', String(visible));
        }
      }
    };

    const syncUrl = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('type');
      for (const option of chosen()) url.searchParams.append('type', option.value);
      window.history.replaceState({}, '', url);
    };

    const run = async () => {
      paint();
      syncUrl();
      if (chosen().length > 0 && infinite && typeof infinite.loadAll === 'function') {
        await infinite.loadAll();
        paint();
      }
    };

    typeFilter.addEventListener('change', run);
    document.addEventListener('collection:appended', paint);

    // Restore a shared or bookmarked selection.
    const preset = new URL(window.location.href).searchParams
      .getAll('type')
      .map((value) => value.toLowerCase());
    if (preset.length > 0) {
      let matched = false;
      for (const option of options) {
        if (preset.includes(option.value.toLowerCase())) {
          option.checked = true;
          matched = true;
        }
      }
      if (matched) {
        typeFilter.open = true;
        run();
      }
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-marquee"] && !Shopify.designMode) return;
  try {
    
  // Re-render the drop moment in the visitor's own timezone and locale.
  // The datetime attribute carries the merchant-entered Türkiye time
  // as an ISO timestamp (+03:00); Date/Intl do the conversion.
  const localiseDropTimes = (root) => {
    for (const node of root.querySelectorAll('[data-drop-local]')) {
      const stamp = new Date(node.getAttribute('datetime'));
      if (Number.isNaN(stamp.getTime())) continue;
      try {
        node.textContent = new Intl.DateTimeFormat(
          document.documentElement.lang || 'en',
          { dateStyle: 'long', timeStyle: 'short' }
        ).format(stamp);
      } catch (error) {
        // Keep the server-rendered Türkiye-time fallback
      }
    }
  };

  localiseDropTimes(document);
  document.addEventListener('shopify:section:load', (event) => localiseDropTimes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Cart icon opens the drawer when it exists; falls back to /cart link.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-cart-toggle]');
    if (!toggle) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open(toggle);
    }
  });

  // Wishlist count badge, kept in sync with the localStorage-backed list.
  const updateWishlistBadge = () => {
    const badge = document.querySelector('[data-wishlist-count-badge]');
    if (!badge) return;
    let count = 0;
    try {
      const list = JSON.parse(localStorage.getItem('nafos:wishlist'));
      count = Array.isArray(list) ? list.length : 0;
    } catch {
      count = 0;
    }
    badge.textContent = count;
    badge.classList.toggle('is-empty', count === 0);
  };
  updateWishlistBadge();
  document.addEventListener('wishlist:updated', updateWishlistBadge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // ----- Thumbnail strip: scroll-more button + edge fade -----
  // One button does double duty: a vertical "show more" nudge on desktop
  // (column layout, chevron pointing down) and a horizontal one on mobile
  // (row layout, chevron rotated to point right via CSS). Only the axis
  // that's actually scrollable will move when clicked; the other is a
  // no-op, so the same handler works unmodified at both breakpoints.
  const initThumbsNav = (wrapper) => {
    if (wrapper.dataset.thumbsNavInit) return;
    wrapper.dataset.thumbsNavInit = 'true';

    const list = wrapper.querySelector('[data-thumbs]');
    const nav = wrapper.querySelector('[data-thumbs-nav]');
    if (!list || !nav) return;

    const update = () => {
      const hasOverflow = list.scrollHeight > list.clientHeight + 2 || list.scrollWidth > list.clientWidth + 2;
      const atEnd =
        list.scrollTop + list.clientHeight >= list.scrollHeight - 2 &&
        list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      nav.hidden = !hasOverflow || atEnd;
    };

    nav.addEventListener('click', () => {
      list.scrollBy({ top: 120, left: 120, behavior: 'smooth' });
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initProductGalleryNav = (root) => {
    for (const wrapper of root.querySelectorAll('.product__thumbs-wrap')) initThumbsNav(wrapper);
  };

  // Keep the small folio counter and thumbnail state in sync with the
  // scroll-snap gallery. Product videos only play while their slide is
  // current and the gallery is visible, avoiding background playback.
  const initProductMedia = (gallery) => {
    if (gallery.dataset.productMediaInit) return;
    gallery.dataset.productMediaInit = 'true';

    const track = gallery.querySelector('[data-carousel-track]');
    const slides = Array.from(gallery.querySelectorAll('.product__media'));
    const thumbs = Array.from(gallery.querySelectorAll('.product__thumb'));
    const current = gallery.querySelector('[data-media-current]');
    if (!track || !slides.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let isVisible = false;
    let frame = 0;

    const sync = () => {
      frame = 0;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = Math.max(1, track.clientWidth + gap);
      const index = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / step)));

      if (current) current.textContent = String(index + 1).padStart(2, '0');
      for (const [thumbIndex, thumb] of thumbs.entries()) {
        if (thumbIndex === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      }

      for (const [slideIndex, slide] of slides.entries()) {
        const video = slide.querySelector('video');
        if (!video) continue;
        if (slideIndex === index && isVisible && !reducedMotion.matches && !document.hidden) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    };

    const queueSync = () => {
      if (frame) return;
      frame = requestAnimationFrame(sync);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        isVisible = entries.some((entry) => entry.isIntersecting);
        sync();
      },
      { threshold: 0.2 }
    );

    observer.observe(track);
    track.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync, { passive: true });
    document.addEventListener('visibilitychange', sync);

    // Thumbs are plain anchors (#Media-…) so they still work without JS, but
    // the default jump also scrolls the page vertically. Glide only the
    // gallery track instead.
    for (const [thumbIndex, thumb] of thumbs.entries()) {
      thumb.addEventListener('click', (event) => {
        const slide = slides[thumbIndex];
        if (!slide) return;
        event.preventDefault();
        const delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollBy({ left: delta, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
    }

    sync();
  };

  const initProductMediaGalleries = (root) => {
    for (const gallery of root.querySelectorAll('.product__gallery')) initProductMedia(gallery);
  };

  initProductGalleryNav(document);
  initProductMediaGalleries(document);

  // ----- Judge.me review widget: store reviews only -----
  // The widget always opens on "Product reviews", which is permanently "(0)"
  // for a shop that collects store-level reviews — so visitors landed on an
  // empty pane. Click the store tab the moment the Vue widget renders it
  // (a hidden button still runs its handler); CSS keeps the tab strip hidden.
  const initJudgemeStoreTab = () => {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!widget || widget.dataset.storeTabInit) return;

    const activate = () => {
      const tabs = [...widget.querySelectorAll('button.jdgm-tab')];
      if (!tabs.length) return false;
      const storeTab = tabs.find((tab) => !/product/i.test(tab.textContent)) || tabs[tabs.length - 1];
      widget.dataset.storeTabInit = 'true';
      if (storeTab.getAttribute('aria-selected') !== 'true') storeTab.click();
      return true;
    };

    if (activate()) return;
    const observer = new MutationObserver(() => {
      if (activate()) observer.disconnect();
    });
    observer.observe(widget, { childList: true, subtree: true });
    // Give up quietly if Judge.me never renders.
    setTimeout(() => observer.disconnect(), 15000);
  };

  initJudgemeStoreTab();
  document.addEventListener('shopify:section:load', (event) => {
    initProductGalleryNav(event.target);
    initProductMediaGalleries(event.target);
    initJudgemeStoreTab();
  });

  } catch(e) { console.error(e); }
})();
})();
